import { useState, useEffect } from "react"
import { useCalculator } from "../context/CalculatorContext"
import { validateShipmentsInputs } from "../utils/formHelpers"
import { calculateNumberOfTrackedAssets } from "../utils/calculations"

export const useShipmentsForm = () => {
  const { shipments, setShipments } = useCalculator()
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})
  const [numberOfTrackedAssets, setNumberOfTrackedAssets] = useState<
    number | ""
  >("")

  useEffect(() => {
    if (shipments.yearlyVolume && shipments.percentageToTrack) {
      const trackedAssets = calculateNumberOfTrackedAssets(
        shipments.yearlyVolume,
        shipments.percentageToTrack,
      )
      setNumberOfTrackedAssets(trackedAssets)
    } else {
      setNumberOfTrackedAssets("")
    }
  }, [shipments.yearlyVolume, shipments.percentageToTrack])

  const handleInputChange = (key: keyof typeof shipments, value: string) => {
    const numericValue = Number(value)
    setShipments({
      ...shipments,
      [key]: numericValue ?? "",
    })
  }

  const validateInputs = (): boolean => {
    const { isValid, errors } = validateShipmentsInputs(shipments)

    setFormErrors(errors)
    return isValid
  }

  return {
    shipments,
    formErrors,
    numberOfTrackedAssets,
    handleInputChange,
    validateInputs,
  }
}
